import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { contractReviewerActions as actions, analysisActions } from '../../actions';
import { contractReviewerConstants } from '../../constants';
import MissingConceptTextBox from './MissingConceptTextBox';
import '../../content/css/MissingConcepts.css';
import { LoadingIcon } from '../LoadingIcon';
import LoadingListener from '../../helpers/loadingListener';

class MissingConceptList extends Component {

    constructor(props, context) {
        super(props, context);

        this.loadingListener = new LoadingListener([contractReviewerConstants.GET_DOCUMENT_ANALYSIS_REQUEST]);
    }

    componentDidMount() {
        const { reportId, docId } = this.props.match.params;
        if (this.props.id !== docId) this.props.requestDocumentAnalysis(docId, reportId);
        if (reportId && this.props.reportId != reportId) {
            this.props.requestPortfolioAnalysis(reportId);
        }
    }

    getCurrentDocument() {
        let doc = this.props.analyzedDocuments[this.props.id];
        doc = doc ? doc : {
            highlights: [],
            missingHighlights: [],
            segments: []
        };

        return doc;
    }

    getMissingConcepts() {
        return this.getCurrentDocument().missingHighlights.map((segment, i) => (
            <MissingConceptTextBox
                title={segment.categoryName}
                text={segment.feedbackMissingGuidance}
                warnWhenMissing={segment.warnWhenMissing}
            />
        ));
    }

    getHeader() {
        let doc = this.getCurrentDocument();
        if (doc.missingHighlights && doc.missingHighlights.length > 0) return "You have important concepts missing in your document!";
        else return "We found no concepts missing in the contract per your guidelines."
    }

    render() {
        let isLoading = this.loadingListener.isLoading(this.props.isLoading);

        return (
            <div className="overview">
                {isLoading &&
                    <LoadingIcon />
                }

                {!isLoading &&
                    <div className="missing-concepts">
                        <Row className="title"><strong>{this.getHeader()}</strong></Row>

                        <Row className="list">
                            {this.getMissingConcepts()}
                        </Row>
                    </div>
                }
            </div>
        );
    }
}

export default connect(
    state => {
        const { contractReviewer, analysis } = state;
        return {...contractReviewer, reportId: analysis.id };
    },
    dispatch => bindActionCreators({...actions, requestPortfolioAnalysis: analysisActions.requestPortfolioAnalysis }, dispatch)
)(MissingConceptList);



// WEBPACK FOOTER //
// ./src/components/MissingConcepts/MissingConceptList.js